import { CHCMetaTagReplacer } from "./meta-tag-replacer.component.js";
customElements.define("chc-meta-tag-replacer", CHCMetaTagReplacer);
export {
  CHCMetaTagReplacer
};
//# sourceMappingURL=meta-tag-replacer.js.map
